import {OnInit, OnDestroy, AfterViewInit, ViewChildren, QueryList, forwardRef, ForwardRefFn, Type} from '@angular/core';
import {NgForm, NgModel, ControlContainer, AbstractControl} from '@angular/forms';
import * as Rx from 'rxjs/rx';
export {QueryList};

export abstract class ReactiveComponent implements OnInit, OnDestroy, AfterViewInit {
    abstract ngOnInit(): void;
    protected _subscriptions: Rx.Subscription[] = [];
    private __viewInit = new Rx.ReplaySubject<void>(1);
    protected _viewInit: Rx.Observable<void> = this.__viewInit;
    ngOnDestroy() {
        if (this._subscriptions)
            this._subscriptions.forEach(s => s.unsubscribe());
    }
    ngAfterViewInit() {
        this.__viewInit.next(null);
        this.__viewInit.complete();

    }


    get $instance() {
        return this;
    }

}

export function DynamicFormFactory(parent: DynamicFormComponent)
{
    return parent.formDirective;
}


// export function dynamicFormDirectiveProvider(type: Type<any>) {
//     return {
//         provide: ControlContainer,
//         useExisting: type
//     };
// }
export abstract class DynamicFormComponent {

    constructor(private _form: NgForm) {
    }

    get formDirective(): NgForm { return this._form; }
    protected _subscriptions: Rx.Subscription[] = [];
    private __viewInit = new Rx.ReplaySubject<void>(1);
    protected _viewInit: Rx.Observable<void> = this.__viewInit;
    ngOnDestroy() {
        if (this._subscriptions)
            this._subscriptions.forEach(s => s.unsubscribe());
    }
    ngAfterViewInit() {
        this.__viewInit.next(null);
        this.__viewInit.complete();

    }

    get $instance() {
        return this;
    }
}



//export interface SkipUntilAndReplaySignature<T> {
//    (v2: Rx.Observable<any>, bufferSize?: number, windowSize?: number): Rx.Observable<T>;
//}

//declare module 'rxjs/Observable' {
//    interface Observable<T> {
//        skipUntilReplay: SkipUntilAndReplaySignature<T>;
//    }
//}

//Rx.Observable.prototype.skipUntilReplay = function <T>(other: Rx.Observable<any>, bufferSize?: number, windowSize?: number) {
//    var _this = <Rx.Observable<T>>this;
//    var buffer: Rx.Subject<T> = new Rx.ReplaySubject<T>(bufferSize, windowSize);
//    _this.subscribe(ret => buffer.next(ret));
//    let published = buffer.publish();
//    other.do(null, null, () => {
//        debugger;
//        published.connect();
//    });
//    return published;

//};


// WEBPACK FOOTER //
// F:/Agent/vsts-agent1/_work/76/s/CIA.ClientSide/~/@wtw/toolkit/src/utils/base.component.ts